import React from 'react'

const AgbDE = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: '@import url(https://themes.googleusercontent.com/fonts/css?kit=sDU-RIIs3Wq_4pUcDwWu-05zdwzqyXAFhQ3EpAK6bTA);ol{margin:0;padding:0}table td,table th{padding:0}.c2{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left;height:11pt}.c11{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:15pt;font-family:"Albert Sans";font-style:normal}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c6{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c5{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Albert Sans";font-style:normal}.c7{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:26pt;font-family:"Albert Sans";font-style:normal}.c13{color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-family:"Cambria";font-style:normal}.c3{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c10{text-decoration-skip-ink:none;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c8{background-color:#ffffff;max-width:451.5pt;padding:72pt 72pt 72pt 72pt}.c12{font-family:"Cambria";font-weight:400}.c0{color:inherit;text-decoration:inherit}.c9{height:11pt}.c4{font-size:12pt}.c14{color:#1155cc}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c3">
                <span className="c1">Allgemeine Geschäftsbedingungen</span>
            </p>
            <p className="c3">
                <span className="c1">Stand: Februar 2024 </span>
            </p>
            <p className="c3">
                <span className="c1">
                    Die nachfolgenden Bedingungen regeln den über die Website von Wemolo GmbH (nachfolgend: Wemolo)
                    abgeschlossenen Mietvertrag, der zwischen dem Nutzer der Parkfläche (nachfolgend: Mieter) und dem
                    Berechtigten des vertragsgegenständlichen Stellplatzes (nachfolgend: Vermieter) zustande kommt.
                    Verwender dieser Allgemeinen Geschäftsbedingungen ist der Vermieter. Wemolo stellt zum Zwecke des
                    einfacheren Zustandekommens des Mietvertrages die technischen Voraussetzungen (Website,
                    Eingabemaske) zur Verfügung und erleichtert dadurch den Abschluss des Mietvertrages. Darüber
                    hinausgehende Leistungen (wie insbesondere Vermittlungs- oder Maklerleistungen) werden von Wemolo
                    nicht erbracht. Die Kontakt- und Adressdaten des Vermieters werden dem Mieter auf Anfrage durch
                    Wemolo mitgeteilt. Sofern sich die Formulierungen dieser AGB allein auf die männliche Form beziehen,
                    sind Personen aller Geschlechter miterfasst.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vermietung von Stellplätzen
                </span>
            </p>
            <p className="c3" id="h.30j0zll">
                <span className="c1">
                    1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gegenstand des Vertrags ist die Vermietung von
                    Stellplätzen zum Abstellen eines bei der Buchung mittels Kennzeichen angegebenen PKWs oder Motorrads
                    (nachfolgend: Fahrzeug). Die Stellplätze befinden sich auf bzw. in von Wemolo verwalteten privaten
                    Parkflächen, Parkhäusern und Tiefgaragen. Wemolo ist vom Vermieter bevollmächtigt, den Interessenten
                    im Namen des Vermieters vordefinierte Angebote zum Abschluss von Mietverträgen über die Website
                    automatisiert bereitzustellen. Sofern nicht ausdrücklich anders vereinbart, wird dem Mieter kein
                    konkreter Stellplatz zugewiesen, sondern die Erlaubnis eingeräumt, einen Stellplatz seiner Wahl für
                    den gebuchten Zeitraum entsprechend den vertraglichen Bedingungen zu benutzen. Im Buchungsprozess
                    angezeigte Parkzonen sind vom Mieter zu berücksichtigen.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Die Vermietung erfolgt für bestimmte, während der
                    Buchung ersichtliche Zeiträume, im Rahmen derer der Mieter (z.B. über Nacht oder am Wochenende)
                    berechtigt ist, das bei der Buchung angegebene Fahrzeug auf einem von ihm auszuwählenden Stellplatz
                    abzustellen. Außerhalb dieser Zeiten ist der Stellplatz vom Mieter freizuhalten.
                    Sonderbeschilderungen vor Ort (z.B. Parkverbote, Reservierungen, etc.) sind vom Mieter entsprechend
                    zu beachten.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vertragsschluss</span>
            </p>
            <p className="c3">
                <span className="c1">
                    2.1 Interessenten können über die Eingabemaske auf der Website von Wemolo eine unverbindliche
                    Mietanfrage stellen.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    2.2 Wemolo prüft sodann auf automatisiertem Wege die Verfügbarkeit eines geeigneten Stellplatzes auf
                    der verwalteten Parkfläche. Soweit möglich, unterbreitet der Vermieter (automatisiert über die
                    Website von Wemolo) dem Interessenten anschließend ein Angebot auf Abschluss eines Mietvertrags.
                    Wird dieses Angebot angenommen, kommt zwischen dem Interessenten und dem Vermieter ein Mietvertrag
                    zustande.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    2.3 Wemolo als Betreiber der Website kann Mietanfragen jederzeit ohne Angabe von Gründen ablehnen.
                    Ein Anspruch auf Abschluss eines Mietvertrags besteht nicht.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    2.4 Der gemietete Stellplatz kann ausschließlich mit dem bei der Buchung angegebenen Fahrzeug
                    genutzt werden.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Verhältnis zu AGB von Dritten
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    Sollte auf der von Wemolo verwalteten Fläche neben der Buchungsplattform auch eine weitere von einem
                    Dritten angebotene Dienstleistung zum Einsatz kommen, so gehen für den Mieter mit
                    Mietvertragsabschluss im Falle eines Widerspruchs die AGB der Buchungsplattform vor.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Miete</span>
            </p>
            <p className="c3">
                <span className="c1">
                    4.1 Mit Vertragsschluss verpflichtet sich der Mieter, die vereinbarte Miete fristgerecht zu
                    entrichten.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    4.2 Die Miete kann über die online zur Verfügung gestellten Zahlungsarten entrichtet werden.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Vertragslaufzeit</span>
            </p>
            <p className="c3">
                <span className="c4">
                    5.1 Der Mieter mietet den Stellplatz für den vereinbarten Zeitraum. Eine Übersicht über eine
                    Rückerstattung bei vorzeitiger Stornierung der Buchung findet sich in unseren
                    Stornierungsbedingungen:{' '}
                </span>
                <span className="c4 c10">
                    <a className="c0" href="https://go.wemolo.de/legal/cancellation-policy">
                        https://go.wemolo.de/legal/cancellation-policy
                    </a>
                </span>
                <span className="c4 c14">.</span>
                <span className="c1">
                    &nbsp;Ein etwaiges Widerrufsrecht des Mieters wird dadurch nicht beschränkt.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    5.2 Der Vermieter kann den Mietvertrag außerordentlich mit einer Frist von zwei Wochen kündigen,
                    wenn er das Grundstück, auf dem sich der Stellplatz befindet, veräußert oder seine Berechtigung zur
                    Vermietung anderweitig, insbesondere infolge einer Beendigung des Pachtverhältnisses verliert.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    5.3 Das beiderseitige Recht zur außerordentlichen fristlosen Kündigung aus wichtigem Grund bleibt
                    unberührt.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Nutzung des Stellplatzes</span>
            </p>
            <p className="c3">
                <span className="c1">
                    6.1 Der Stellplatz darf ohne anderweitige schriftliche Erlaubnis des Vermieters oder Wemolos nur
                    dazu genutzt werden, das bei der Buchung angegebene Fahrzeug abzustellen. Auf dem angemieteten
                    Stellplatz darf nur das vertraglich festgelegte Fahrzeug abgestellt werden, welches anhand seines
                    mitgeteilten amtlichen Kennzeichens als solche identifiziert werden kann. Davon unberührt bleibt die
                    Möglichkeit, mit weiteren KFZ die Parkfläche im Rahmen des üblichen Publikumsverkehrs zu
                    frequentieren oder weitere Stellplätze zu mieten. Ansprechpartner des Mieters ist Wemolo.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    6.2 Soweit der Mieter nicht zugleich Halter des festgelegten Fahrzeugs ist, ist er verpflichtet, vor
                    der Anmietung des Stellplatzes sicherzustellen, dass auch der Fahrzeughalter mit der Nutzung
                    einverstanden ist.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    6.3 Sonstige Gegenstände darf der Mieter grundsätzlich nicht auf dem Stellplatz lagern.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    6.4 Der Mieter hat die Straßenverkehrsordnung zu beachten. Das Einstellen von Fahrzeugen ohne oder
                    ohne erkennbares amtliches Kennzeichen oder mit undichten Treibstoffanlagen oder anderen Mängeln,
                    die den Betrieb der Parkeinrichtung gefährden, ist unzulässig. Das Abstellen von Fahrzeugen mit
                    Flüssiggas ist in Tiefgaragen allgemein untersagt. Das unnötige Laufenlassen von Motoren sowie
                    sonstige Geruchs- und Lärmbelästigungen sind zu vermeiden. Ein Reinigen oder Betanken des Fahrzeugs
                    oder Arbeiten an diesem sind auf dem Stellplatz und der gesamten Parkfläche nicht gestattet.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    6.5 Der Parkplatz ist nicht gegen Diebstahl und Vandalismus gesichert. Der Mieter hat sein Fahrzeug
                    und darin befindliche Gegenstände auf eigene Verantwortung vor einer unbefugten Entwendung durch
                    Dritte zu schützen.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Untervermietung und Abschleppen widerrechtlich
                    parkender KFZ
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    7.1 Eine Untervermietung oder unentgeltliche Gebrauchsüberlassung an Dritte ist nur mit Erlaubnis
                    des Vermieters gestattet.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    7.2 Der Vermieter behält sich die Möglichkeit vor, widerrechtlich auf dem vermieteten Stellplatz
                    abgestellte KFZ auf Kosten des Halters abzuschleppen. Widerrechtlich abgestellt sind solche
                    Fahrzeuge, die mietvertraglich nicht zur Nutzung des Stellplatzes festgelegt wurden oder gegen
                    Ziffer 6.4 verstoßen.
                </span>
            </p>
            <p className="c3">
                <span className="c1">8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Haftung des Mieters</span>
            </p>
            <p className="c3">
                <span className="c1">
                    Der Mieter haftet für Verunreinigungen (bspw. durch Öl oder Benzin) sowie für alle Schäden, die bei
                    der Benutzung des Stellplatzes oder infolge der Nichtbeachtung vertraglicher oder gesetzlicher
                    Vorschriften durch ihn selbst oder durch andere Personen, denen er die Benutzung seines
                    Kraftfahrzeugs bzw. des Stellplatzes gestattet hat, schuldhaft verursacht werden.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Haftung des Vermieters</span>
            </p>
            <p className="c3">
                <span className="c1">
                    9.1 Der Vermieter hat auftretende bzw. bestehende Mängel an der Mietsache selbst unverzüglich zu
                    beseitigen, sofern diese Mängel nicht durch den Mieter bzw. durch Personen, denen der Mieter die
                    Benutzung des Stellplatzes gestattet hat, schuldhaft verursacht wurden und der Vermieter vom Mieter
                    auf diese Mängel hingewiesen wurde. Für Schäden, die durch die nicht unverzügliche Beseitigung der
                    Mängel entstanden sind, haftet der Vermieter.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    9.2 Der Vermieter haftet ebenfalls für alle Schäden, die dem Mieter dadurch entstehen, dass der
                    Vermieter nicht seinen vertraglichen oder gesetzlichen Pflichten nachgekommen ist, es sei denn, dem
                    Vermieter kann diesbezüglich nur einfache Fahrlässigkeit zur Last gelegt werden. Für Schäden aus der
                    Verletzung des Lebens, des Körpers oder der Gesundheit haftet der Vermieter dagegen auch dann, wenn
                    ihm nur einfache Fahrlässigkeit vorzuwerfen ist.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    9.3 Der Vermieter achtet darauf, gebuchte Stellplätze auch bereitstellen zu können. In Einzelfällen
                    ist es jedoch möglich, dass trotz gültiger Buchung kein Stellplatz verfügbar ist. Dem Mieter kommt
                    in solchen Fällen ein außerordentliches Kündigungsrecht zu, sofern es sich nicht nur um eine
                    zeitlich geringfügige Einschränkung der Nutzbarkeit des Stellplatzes handelt. Zusätzlich besteht ein
                    anteiliger Anspruch auf Rückerstattung der Zahlungen für den Zeitraum der Nichtverfügbarkeit. Für
                    darüber hinausgehende Ansprüche (z.B. Schadenersatz, entgangener Gewinn, mittelbare Schäden,
                    Ansprüche Dritter) haftet der Vermieter nur, wenn die Nichtverfügbarkeit durch den Vermieter grob
                    fahrlässig oder vorsätzlich verursacht wurde.
                </span>
            </p>
            <p className="c3">
                <span className="c4">
                    10.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Höchstparkdauer und Vertragsstrafe bei
                    Zuwiderhandlungen
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    10.1 Mit Abschluss des Mietvertrages verpflichtet sich der Mieter, die vereinbarte Mietdauer
                    einzuhalten. Für diese Ziffer 10 gilt als vereinbarte Mietdauer die auf der Buchungsplattform durch
                    den Mieter gebuchte Mietdauer sowie zusätzlich die kostenfreie Höchstparkdauer, soweit auf der
                    verwalteten Fläche angeboten.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    10.2 Für den Fall, dass der Mieter unberechtigt die vereinbarte Mietdauer überschreitet, schuldet er
                    neben der vereinbarten Miete zusätzlich die Miete, die für die tatsächliche Mietdauer angefallen
                    wäre. Nummer 10.3 bleibt hiervon unberührt.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    10.3 Für den Fall, dass der Mieter unberechtigt die vereinbarte Mietdauer überschreitet oder sein
                    Fahrzeug auf einem reservierten Stellplatz oder in einer markierten Halteverbotszone abstellt,
                    schuldet der Mieter die bei der Buchung auf der Plattform angegebene Vertragsstrafe. Diese
                    beinhaltet die MwSt.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    10.4 Ab einer Überschreitung von 24 Stunden erhöht sich die bei der Buchung angegebene
                    Vertragsstrafe pro angefangenem Tag um die bei der Buchung angegebene Vertragsstrafe. Dies gilt bis
                    zu einer Obergrenze von 750 EUR (inkl. MwSt). Der Vermieter behält sich das Recht vor, zusätzlich
                    etwaig erforderliche Auslagen im Zusammenhang mit der Beitreibung der Vertragsstrafe geltend zu
                    machen.
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    10.5 Bei Fahrzeugen mit ausländischen Kennzeichen wird aufgrund der erschwerten Identitätsermittlung
                    und Beitreibbarkeit der verwirkten Vertragsstrafe ein zusätzlich anfallender Verwaltungsaufwand in
                    Rechnung gestellt, allerdings nur bis zu einer Höhe von maximal 20 EUR zzgl. MwSt..{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c4">
                    10.6 Nach Abfrage der Halterdaten bei den zuständigen Stellen wird dem Mieter die Forderung aus 10.2
                    und 10.3
                </span>
                <span className="c4">&nbsp;</span>
                <span className="c4">
                    in Rechnung gestellt. Die Forderungen sind nach Rechnungsstellung sofort zur Zahlung fällig.
                </span>
                <span className="c4 c12">&nbsp;</span>
            </p>
            <p className="c3">
                <span className="c1">11.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Allgemeine Regelungen</span>
            </p>
            <p className="c3">
                <span className="c1">
                    11.1 Es gilt das Recht der Bundesrepublik Deutschland. Ist der Mieter Verbraucher, gilt dies nicht
                    in Bezug auf solche Bestimmungen, die nach dem Recht, das ohne diese Klausel anwendbar wäre (also in
                    der Regel des Landes, wo der Verbraucher seinen Hauptwohnsitz hat), zwingend anwendbar sind und von
                    denen nicht durch Vereinbarung abgewichen werden darf.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c1">
                    11.2 Sofern der Mieter Unternehmer ist, keinen allgemeinen Gerichtsstand in Deutschland oder in
                    einem anderen EU-Mitgliedstaat hat, seinen festen Wohnsitz nach Vertragsschluss ins Ausland verlegt
                    hat oder sein Wohnsitz oder gewöhnlicher Aufenthaltsort im Zeitpunkt der Klageerhebung nicht bekannt
                    ist, liegt der Gerichtsstand für sämtliche Streitigkeiten aus diesem Vertragsverhältnis in München.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c4">
                    11.3 Beabsichtigte Änderungen der AGB werden dem Mieter spätestens einen Monat vor der geplanten
                    Änderung per E-Mail inkl. Bekanntgabe des geplanten Datums des Inkrafttretens zugeschickt. Die
                    geänderten AGB werden mit Zustimmung des Mieters Vertragsinhalt. Der Vermieter behält sich das Recht
                    vor, den Vertrag unter Einhaltung einer Kündigungsfrist von sechs Wochen zum Monatsletzten zu
                    kündigen, wenn der Mieter seine Zustimmung nicht erteilt.{' '}
                </span>
            </p>
            <p className="c3">
                <span className="c4">
                    11.4 Die EU-Kommission stellt eine Online-Plattform zur Online-Streitbeilegung (OS-Plattform)
                    bereit. Sie ist unter dem Link{' '}
                </span>
                <span className="c10 c4">
                    <a
                        className="c0"
                        href="https://www.google.com/url?q=http://ec.europa.eu/consumers/odr/&sa=D&source=editors&ust=1712266780542658&usg=AOvVaw2yUXvo9H9F02fg7rZq7KaA"
                    >
                        http://ec.europa.eu/consumers/odr/
                    </a>
                </span>
                <span className="c1">
                    &nbsp;erreichbar. Weder der Vermieter noch Wemolo als Vermittler sind verpflichtet oder bereit, an
                    einem alternativen Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </span>
            </p>
            <p className="c3 c9">
                <span className="c11" />
            </p>
            <p className="c2">
                <span className="c5" />
            </p>
        </>
    )
}

export default AgbDE
